import type { ReactNode } from 'react';
import type { ColumnDef } from '@tanstack/react-table';
import type { PcmpMarketingQueueItem } from '../../types/pcmpMarketing.types';
import { MisExplanationCell } from '../PcmpQueue/PcmpQueueCells';
import { getPcmpQueueColumns } from '../PcmpQueue/pcmpQueueColumns';

interface PcmpMarketingColumnOptions {
  /** The MIS Not Verified tab adds the reason and explanation column. */
  showMisColumn: boolean;
  renderActions: (item: PcmpMarketingQueueItem) => ReactNode;
}

export function getPcmpMarketingColumns({
  showMisColumn,
  renderActions,
}: PcmpMarketingColumnOptions): ColumnDef<PcmpMarketingQueueItem>[] {
  return getPcmpQueueColumns<PcmpMarketingQueueItem>({
    isOptional: (item) => item.action?.isOptional ?? false,
    afterLanes: showMisColumn
      ? [
          {
            id: 'misExplanation',
            header: 'Not Verified & Explanation',
            cell: ({ row }) => <MisExplanationCell item={row.original} />,
          },
        ]
      : [],
    renderActions,
  });
}
